<template>
  <!-- 服务单状态组件 -->
  <div>
    <van-swipe-cell v-for="(sv,idx) in serviceList" :key="idx">
      <van-cell @click="handleServiceSc(sv)">
        <template #title>
          <span v-if="sv.sumPrice && showPrice" class="text-bold">￥{{sv.sumPrice.toFixed(2)}}：</span>
          <span>{{sv.title}}</span>
          <van-tag class="pull-right" :type="sv.statusStyle">{{sv.statusCN}}</van-tag>
        </template>
        <template #label>
          <span :class="sv.roomNum ? '' : 'pull-right'"
                v-if="sv.cancelReason">取消原因：{{sv.cancelReason}}</span>
          <p class="mar-top-5 mar-btm-0">
            <span v-show="sv.roomNum">{{sv.roomNum}}</span>
            <span :class="(sv.roomNum && sv.roomNum.length) < 20
                          ? 'pull-right' : 'display-block'">{{sv.label}}</span>
          </p>
        </template>
      </van-cell>
      <template #right>
        <van-button v-for="(ele,idx) in getBtnList(sv)" :key="idx"
                    :text="ele.text" :type="ele.style"
                    class="hgt-100-percent" square
                    @click="handleServiceStatus(sv, ele)">
        </van-button>
        <van-button v-show="!getBtnList(sv).length" square type="danger" class="hgt-100-percent" disabled>
          <i class="fa fa-ban text-center" style="width: 28px"></i>
        </van-button>
      </template>
    </van-swipe-cell>

    <cancel-sheet :show="showCancelPopup" :params="cancelParams" @reload="$emit('reload-service')"
                  @handle-cancel="showCancelPopup = $event"></cancel-sheet>
  </div>
</template>

<script>
  import {getStorage, StorageKey} from "../../../tools/storage";
  import {serviceConfig} from "../../../config/common";
  import {service} from "../../../server"
  import {messageHdl, msgCode} from "../../../tools/messageHdlr";
  import {checkRespCorrect, frontConfirm} from "../../../tools/utils";
  import routerMeta from "../router/routerMeta";
  import CancelSheet from "./CancelSheet"

  const btnStyle = {
    cancel: {
      text: "取消",
      style: "danger",
      status: serviceConfig.status.CANCELED,
    },
    reject: {
      text: "拒绝",
      style: "danger",
      status: serviceConfig.status.CANCELED,
    },
    accept: {
      text: "接受",
      style: "primary",
      status: serviceConfig.status.PROCESSING,
    },
    finish: {
      text: "完成",
      style: "primary",
      status: serviceConfig.status.COMPLETED,
    },
  };

  export default {
    components: {
      CancelSheet
    },
    props: {
      serviceList: Array,
      showPrice: Boolean,
    },
    data() {
      return {
        userId: getStorage(StorageKey.userId),
        showCancelPopup: false,
        cancelSvId: ""
      }
    },
    computed: {
      isSelfService() {
        return this.$route.name === routerMeta.selfService.name
      },
      cancelParams() {
        return {
          serviceId: this.cancelSvId,
          status: serviceConfig.status.CANCELED,
        }
      }
    },
    mounted() {
    },
    methods: {
      getBtnList(sv) {
        if (serviceConfig.doneStatus.includes(sv.status)) return [];
        if (this.isSelfService) {
          if (sv.initiator && sv.initiator.userId === this.userId) {
            return [btnStyle.cancel]
          }
        } else {
          switch (sv.status) {
            case serviceConfig.status.NOTSTART:
              return [btnStyle.accept, btnStyle.reject];
            case serviceConfig.status.PROCESSING:
              return [btnStyle.finish, btnStyle.cancel];
            default:
          }
        }
        return []
      },
      handleServiceStatus(sv, ele) {
        if (sv.svId) {
          this.cancelSvId = "";
          if (ele.status === serviceConfig.status.CANCELED) {
            this.cancelSvId = sv.svId;
            this.showCancelPopup = true;
            return;
          }
          frontConfirm({msg: `是否确认【${ele.text}】此服务单？`}, () => {
            this.confirmSvStatus(sv.svId, ele.status)
          })
        }
      },
      confirmSvStatus(svId, status) {
        if (this.cancelSvId) {
          return
        }
        this.showCancelPopup = false;
        UILoader.load("执行中...");
        service.changeStatus(this, {
          serviceId: svId,
          status: status,
        }).then(({changeServiceStatus: resp = {}}) => {
          if (checkRespCorrect(resp, "保存失败")) {
            messageHdl({code: msgCode.SUCCESS});
            this.$emit("reload-service")
          }
        }).catch(err => {
          messageHdl({msg: err.message});
        })
      },
      handleServiceSc(sv) {
        if (this.$route.params.mid) return;
        if (sv.meetingId) {
          this.isSelfService
            ? this.$router.push({name: routerMeta.selfServiceToMtDetail.name, params: {mid: sv.meetingId}})
            : this.$router.push({name: routerMeta.serviceInChargeToMtDetail.name, params: {mid: sv.meetingId}})
        }
      },
    }
  }
</script>

<style scoped>
</style>
